













































































































































import {Component, Prop, Watch} from 'vue-property-decorator';
import PickerMixin from '@/views/reports/mixins/picker-mixin';
import PickerBase from './base';
import { UiDatePickerDate } from '@/components/ui/ui-date-picker.vue';
import UrlMixin from '@/components/query/url-mixin';

import _ from 'lodash';
import { mixins } from 'vue-class-component';
import moment from 'moment';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
import query from '@/components/query/query-constructor';

interface TimeRange {
  from:string,
  to:string,
  timezone?:string,
  date:string
}

@Component
export default class PeriodPicker extends mixins(PickerBase, PickerMixin, UrlMixin, PlanLimitsMixin) {
  @Prop({default:true})
  showCompare: boolean;

  @Prop({default: 'YYYY-MM-DD HH:mm:ss'})
  format!: string;
  
  drag: UiDatePickerDate = null;
  
  activeCalendar:'date1' | 'date2' = 'date1'
  compareEnabled = false;

  getTimeFormatted = num => num < 10 ? `0${num}` : num
  times = Array(25).fill(null).map((_, i) => `${this.getTimeFormatted(i)}:00`)

  splitTime = time => {
    const [t1, t2]	= time.split(':')

    const offset = +t2 <= 30 ? 0 : 1
    return +t1 + offset
  }

  rangeDate1:TimeRange = {
    from:'',
    to:'',
    date:'',
    timezone:''
  };

  rangeDate2:TimeRange ={
    from:'',
    to:'',
    date:'',
  };

  get isFullWidth() {
    return this.$vuetify.breakpoint.mdAndUp;
  }

  get pickerColumns(){
    return this.isFullWidth ? 2 : 1
  }

  get activeDateRange(){
    return this.activeCalendar === 'date2' ? this.rangeDate2 : this.rangeDate1;
  }

  set activeDateRange(value:{from:string, to:string, timezone?:string, date:string}){ 
    const key = this.activeCalendar === 'date2' ? 'rangeDate2' : 'rangeDate1';
    this[key] = value
  }

  get activeDateRangeForDatePicker(): UiDatePickerDate {
    return {
      start: moment(this.activeDateRange.from).toDate(),
      end: moment(this.activeDateRange.to).toDate(),
      timezone:this.activeDateRange.timezone
    };
  }

  set activeDateRangeForDatePicker(value: UiDatePickerDate) {
    const from = moment(this.activeDateRange.from);
    const to = moment(this.activeDateRange.to);
    
    this.activeDateRange = {
      ...this.activeDateRange,
      from:moment(value.start)
        .hours(from.hours())
        .minutes(from.minutes())
        .seconds(from.seconds())
        .format(this.format),
      to:moment(value.end)
        .hours(to.hours())
        .minutes(to.minutes())
        .seconds(to.seconds())
        .format(this.format)
    }
  }

  get selectHoursItemsStart() {
    return this.times.slice(0, this.times.length - 1)
  }

  get selectHoursItemsEnd() {
    const startTime = this.splitTime(this.timeFrom)
    if (this.isSameDay) {
      return this.times.slice(1).filter(time => this.splitTime(time) > startTime)
    }
    return this.times.slice(1, this.times.length)
  }

  get isSameDay() {
    return moment(this.activeDateRange.from).isSame(this.activeDateRange.to, 'day')
  }

  @Watch('isFullWidth')
  onIsFullWidthChanged() {
    this.adjustDatePickerPageRange();
  }

  timeChange() {
    this.activeDateRange={
      ...this.activeDateRange,
      date:'customDateTime'
    }
  }

  adjustDatePickerPageRange() {
    const datePicker = this.$refs.datePicker as any;
    datePicker.adjustPageRange();
  }

  get items(): Bemob.ListItem[] {
    return this.baseItems.map((item: any) => ({
      key: item.value,
      title: item.text,
      help: item.help,
      click: () => {
        const rangeCollection = this.getRangeValueColection({timezone:this.rangeDate1.timezone});
        this.activeDateRange = {
          ...this.activeDateRange,
          ...(rangeCollection[item.value] || {}),
          date:item.value
        };
        this.$nextTick(() => {
          this.adjustDatePickerPageRange();
        });
      }
    }));
  }

  textButtonTimeTo(range) {
    const time = moment(range.to).add(1, 'seconds').format('HH')
    return time === '00' ? '24:00' : `${time}:00`
  }

  get textButtonDate1() {
    if(this.rangeDate1.date === 'customDateTime'){
      return `${moment(this.rangeDate1.from).format('DD MMM YYYY HH:mm')}  - ${moment(this.rangeDate1.to).format('DD MMM YYYY')} ${this.textButtonTimeTo(this.rangeDate1)}`;
    } else {
      const item = this.baseItems.find((item) => item.value === this.rangeDate1.date) || this.baseItems[0];
      return item.text;
    }
  }

  get textButtonDate2() {
    if(this.rangeDate2.date === 'customDateTime'){
      return `${moment(this.rangeDate2.from).format('DD MMM YYYY HH:mm')}  - ${moment(this.rangeDate2.to).format('DD MMM YYYY')} ${this.textButtonTimeTo(this.rangeDate2)}`;
    } else {
      const item = this.baseItems.find((item) => item.value === this.rangeDate2.date) || this.baseItems[0];
      return item.text;
    }
  }

  get dateFrom() {
    return moment(this.activeDateRange.from).format('DD MMM YYYY');
  }

  get dateTo() {
    return moment(this.activeDateRange.to).format('DD MMM YYYY');
  }

  get timeFrom() {
    return moment(this.activeDateRange.from).format('HH:mm');
  }

  set timeFrom(value: string) {
    const date = this.getDateWithUpdatedTime(this.activeDateRange.from, value);
   
    this.activeDateRange = {
      ...this.activeDateRange,
      from:`${date}:00`
    }

    if (this.isStartAfterEndTime) {
      this.timeTo = '24:00'
    }
  }

  get timeTo() {
    const time = moment(this.activeDateRange.to).add(1, 'seconds').format('HH')

    return time === '00' ? '24:00' : `${time}:00`
  }

  set timeTo(value: string) {
    this.activeDateRange = {
      ...this.activeDateRange,
      to:moment(this.getDateWithUpdatedTime(this.activeDateRange.to, value))
        .subtract(1, 'seconds')
        .format('YYYY-MM-DD HH:mm:ss')
    }
  }

  resetRange() {
    this.closeMenu();
    this.applyDataFrom({fromUrl:false})
    if(!this.isDashbord){
      this.bus.emit('reload-report');
    }
  }

  setActiveRange(calendar) {
    this.activeCalendar = calendar;
    this.$nextTick(() => {
      this.adjustDatePickerPageRange();
    });
  }

  applyRange() {
    this.closeMenu();

    this.saveRange({isPushUrl:true});

    this.$nextTick(() => {
      if(this.isDashbord){
        this.bus.emit('refresh-dashboard');
      }else{
        this.bus.emit('refresh-report');
      }
    });
  }

  closeMenu() {
    const picker = this.$refs.picker as any;
    picker?.toggleMenu(false);
  }

  toggleCompareReport(value) {
    this.compareEnabled = value;
    this.calcSimilarCompareRange()
    this.$store.commit('tableQueryTemporary', {
      name: 'compareEnabled',
      value: value
    });
  }

  calcSimilarCompareRange() {
    const rangeCollection = this.getRangeValueColection({timezone:this.rangeDate1.timezone})
    const dateForDate2 = {
      today: 'yesterday',
      yesterday: 'customDateTime',
      last3days: 'customDateTime',
      last7days: 'customDateTime',
      last30days: 'customDateTime',
      last24hours: 'customDateTime',
      last48hours: 'customDateTime',
      thisMonth: 'lastMonth',
      lastMonth: 'customDateTime',
      maxAvailable: 'thisMonth',
      customDateTime: 'thisMonth',
    }

    if(['today','yesterday','last3days','last7days','last30days'].includes(this.rangeDate1.date)){
      const diff = moment(this.rangeDate1.to).diff(moment(this.rangeDate1.from), 'days')
      return this.rangeDate2 = {
        from: moment(this.rangeDate1.from)
          .startOf('day')
          .subtract(diff+1, 'days')
          .format(this.format),
        to: moment(this.rangeDate1.to)
          .endOf('day')
          .subtract(diff+1, 'days')
          .format(this.format),
        date:dateForDate2[this.rangeDate1.date]
      }
    }
    
    if(this.rangeDate1.date === 'last24hours'){
      return this.rangeDate2 = {
        from:moment()
          .tz(this.rangeDate1.timezone)
          .startOf('hour')
          .subtract(23+24, 'hours')
          .format(this.format),
        to:moment()
          .tz(this.rangeDate1.timezone)
          .startOf('hour')
          .subtract(24-1, 'hours')
          .format(this.format),
        date:dateForDate2[this.rangeDate1.date]
      }
    }
    
    if(this.rangeDate1.date === 'last48hours'){
      return this.rangeDate2 = {
        from:moment()
          .tz(this.rangeDate1.timezone)
          .startOf('hour')
          .subtract(48 + 47, 'hours')
          .format(this.format),
        to:moment()
          .tz(this.rangeDate1.timezone)
          .startOf('hour')
          .subtract(48 - 1, 'hours')
          .format(this.format),
        date:dateForDate2[this.rangeDate1.date]
      }
    }

    if(this.rangeDate1.date === 'thisMonth'){
      return this.rangeDate2 = {
        ...rangeCollection['lastMonth'],
        date:dateForDate2[this.rangeDate1.date]
      }
    }
    
    if(this.rangeDate1.date === 'lastMonth'){
      return this.rangeDate2 = {
        from:moment()
          .subtract(2, 'months')
          .startOf('month')
          .format(this.format),
        to:moment()
          .subtract(2, 'months')
          .endOf('month')
          .format(this.format),
        date:dateForDate2[this.rangeDate1.date]
      }
    }

    if(this.rangeDate1.date === 'customDateTime' || this.rangeDate1.date === 'maxAvailable'){
      return this.rangeDate2 = {
        ...rangeCollection['thisMonth'],
        date:dateForDate2[this.rangeDate1.date]
      }
    }
    
  }

  mounted() {
    this.bus.on('apply-filters', this.onBusApplyFilters);
    this.bus.on('report-tab-added', this.onBusReportTabAdded);
    this.bus.on('report-tab-updated', this.onBusReportTabUpdated);

    if(this.isDashbord){
      this.applyDataFrom({fromUrl:true})
      this.saveRange({isPushUrl:true});
    }
  }

  onBusReportTabAdded() {
    this.applyDataFrom({fromUrl:true})
    this.saveRange({isPushUrl:false});
  }

  onBusReportTabUpdated() {
    this.applyDataFrom({fromUrl:true})
    this.saveRange({isPushUrl:false});
  }

  onMenuClick() {
    this.activeCalendar = 'date1'
  }

  beforeDestroy() {
    this.bus.off('apply-filters', this.onBusApplyFilters);
    this.bus.off('report-tab-added', this.onBusReportTabAdded);
    this.bus.off('report-tab-updated', this.onBusReportTabUpdated);
  }

  onBusApplyFilters() {
    this.saveRange({isPushUrl:true});
  }

  applyDataFromStore() {

  }

  applyDataFrom({fromUrl}) {
    let dataSource = this.$store.getters.tableQueryForCurrentTab
    if(fromUrl){
      dataSource = query.decode(this.$route.params.data)
    }

    const { from, to, timezone = this.$store.state.user.defaultTimezone, date = 'today' } = dataSource;

    this.rangeDate1 = {
      from,
      to,
      timezone,
      date,
    };

    const rangeCollection = this.getRangeValueColection({timezone:this.activeDateRange.timezone})
    if(this.rangeDate1.date!=='customDateTime') {
      this.rangeDate1 = {
        ...this.rangeDate1,
        from:rangeCollection[this.rangeDate1.date].from,
        to:rangeCollection[this.rangeDate1.date].to
      };
    }

    if(this.showCompare){
      const { compareEnabled = false, compareFrom = null, compareTo = null, compareDate = null } = dataSource;

      this.rangeDate2 = {
        from:compareFrom,
        to:compareTo,
        date:compareDate,
      };

      this.compareEnabled = compareEnabled;

      if(this.rangeDate2?.date && this.rangeDate2?.date!=='customDateTime' ) {
        this.rangeDate2 = {
          ...this.rangeDate2,
          from:rangeCollection[this.rangeDate2.date].from,
          to:rangeCollection[this.rangeDate2.date].to
        };
      }
    }
  }

  get formatedDate() {
    if(this.rangeDate1.date === 'customDateTime'){
      return `${moment(this.rangeDate1.from).format('DD MMM YYYY')} - ${moment(this.rangeDate1.to).format('DD MMM YYYY')}`;
    } else {
      const item = this.baseItems.find((item) => item.value === this.rangeDate1.date) || this.baseItems[0];
      return item.text;
    }
  } 

  handleDrag(value: UiDatePickerDate) {
    if(value) {
       this.drag = value;
       return
    } 
    if(!value && !!this.drag){
      this.activeDateRange={
        ...this.activeDateRange,
        date:'customDateTime'
      };

      this.drag = null;
    }
  }

  get isStartAfterEndTime() {
    return moment(this.activeDateRange.from).isAfter(moment(this.activeDateRange.to))
  }

  getDateWithUpdatedTime(date: any, time: string)   {
    const dateWithoutTime = moment(date).format('YYYY-MM-DD');
    return `${dateWithoutTime} ${time}`;
  }
  
  onTimezoneChange(val: any) {
    this.rangeDate1.timezone = val;
    this.$store.commit(this.storeQueryTemporary.action, {
      name: 'timezone',
      value: val
    });
  }

  getUpdatedRange(val: { to:string, from:string }) {
    if (this.rangeDate1.date !== 'customDateTime') {
      return {
        ...val,
        from: val.from,
        to:val.to,
      };
    }

    let from = val.from?.length === 16 ? val.from + ':00' : val.from;
    let to = val.to?.length === 16 ? val.to + ':59' : val.to

    return {
      ...val,
      from,
      to
    };
  }

  saveRange({isPushUrl}) {
    let rangeDate1:{from:string,to:string,timezone?:string} = this.getUpdatedRange(this.rangeDate1)
    let rangeDate2:{from:string,to:string,timezone?:string} = this.getUpdatedRange(this.rangeDate2)

    const isRange1Changed =
      rangeDate1.from !== this.$store.getters.tableQueryForCurrentTab.from ||
      rangeDate1.to !== this.$store.getters.tableQueryForCurrentTab.to ||
      rangeDate1?.timezone !== this.$store.getters.tableQueryForCurrentTab.timezone ||
      this.rangeDate1?.date !== this.$store.getters.tableQueryForCurrentTab.date

    const isRange2Changed =
      rangeDate2.from !== this.$store.getters.tableQueryForCurrentTab.compareFrom ||
      rangeDate2.to !== this.$store.getters.tableQueryForCurrentTab.compareTo ||
      this.rangeDate2.date !== this.$store.getters.tableQueryForCurrentTab.compareDate ||
      this.compareEnabled !== this.$store.getters.tableQueryForCurrentTab.compareEnabled


    if(this.isDashbord){
      this.$store.commit('dashboardQueryPeriod', {
        from: rangeDate1.from,
        to: rangeDate1.to,
        timezone: rangeDate1.timezone,
        date: this.rangeDate1.date,
      });
    }else{
      this.$store.commit('tablePeriodForCurrentTab', {
        from: rangeDate1.from,
        to: rangeDate1.to,
        timezone: rangeDate1.timezone,
        date: this.rangeDate1.date,
        compareFrom: rangeDate2.from,
        compareTo: rangeDate2.to,
        compareDate: this.rangeDate2.date,
        compareEnabled:this.compareEnabled,
      });
    }
    if(this.showCompare ? isRange1Changed || isRange2Changed : isRange1Changed ) {
      this.bus.emit('reset-offset');
      if(isPushUrl){
        this.$nextTick(() => {
          this.pushURL();
        });
      }
    }
  }

  @Watch('activeDateRange')
  watchRangeChanged(val: any) {
    let updatedRange1 = this.getUpdatedRange(this.rangeDate1);
    let updatedRange2 = this.getUpdatedRange(this.rangeDate2);

    if(this.isDashbord){
      this.$store.commit('dashboardQueryPeriodTemporary', {
        from: updatedRange1.from,
        to: updatedRange1.to,
        timezone: this.rangeDate1.timezone,
        date: this.rangeDate1.date,
      });
    }else{
      this.$store.commit('tablePeriodTemporaryForCurrentTab', {
        from: updatedRange1.from,
        to: updatedRange1.to,
        timezone: this.rangeDate1.timezone,
        date: this.rangeDate1.date,
        compareFrom:updatedRange2.from,
        compareTo:updatedRange2.to,
        compareDate:this.rangeDate2.date,
        compareEnabled:this.compareEnabled,
      });
    }
  }

  get showCompareOnThisPage(){
    const { name } = this.$route;

    switch (name) {
      case 'app.conversions':
      case 'app.postbacks':
      case 'app.errors':
      case 'app.live-clicks':
      case 'app.live-visits':
        return false;

      default:
        return true;
    }
  }
}
